var addDevToolsClickListener = function addDevToolsClickListener(ref, enableDevTools, editor) {
  var clickListener = null;
  var keyDownHandler = function keyDownHandler(e) {
    if (e.metaKey && e.shiftKey && e.altKey && !clickListener) {
      clickListener = function clickListener(e2) {
        if (e2.detail === 2) {
          enableDevTools();
          if (editor && typeof window !== "undefined") {
            import(/* webpackChunkName: "ricos_prosemirror-dev-tools" */
            "prosemirror-dev-tools").then(function (_ref) {
              var applyDevTools = _ref.applyDevTools;
              applyDevTools(editor.view, {});
            }, function (e3) {
              console.error("Failed to load prosemirror-dev-tools", e3);
            });
          }
        }
      };
      ref === null || ref === void 0 ? void 0 : ref.addEventListener("click", clickListener, {
        capture: true
      });
    }
  };
  var keyUpHandler = function keyUpHandler(e) {
    if (!e.metaKey || !e.shiftKey || !e.altKey) {
      if (clickListener) {
        ref === null || ref === void 0 ? void 0 : ref.removeEventListener("click", clickListener);
        clickListener = null;
      }
    }
  };
  document.addEventListener("keydown", keyDownHandler);
  document.addEventListener("keyup", keyUpHandler);
  return function () {
    document.removeEventListener("keydown", keyDownHandler);
    document.removeEventListener("keyup", keyUpHandler);
    if (clickListener) {
      ref === null || ref === void 0 ? void 0 : ref.removeEventListener("click", clickListener);
    }
  };
};
export { addDevToolsClickListener };